import React from 'react';

import './index.scss';

const Footer = () => {
	return (
		<div className='footer-wrapper'>
			<div className='footer-title'>
				<h1>Amy's</h1>
				<h4>NAILS & SPA</h4>
			</div>
			<div className='footer-link-container'>
				<a
					href='https://www.instagram.com/amysnailsandspa68merrick/'
					target='_blank'
					rel='noreferrer'
				>
					<i class='fab fa-instagram'></i>
				</a>
				<a
					rel='noreferrer'
					href='https://www.facebook.com/star.chen.5201254'
					target='_blank'
				>
					<i class='fab fa-facebook-f'></i>
				</a>
				<a
					rel='noreferrer'
					href='https://m.yelp.com/biz/amys-nails-and-spa-amityville'
					target='_blank'
				>
					<i class='fab fa-yelp'></i>
				</a>
			</div>
		</div>
	);
};

export default Footer;
